import { ApolloClient, InMemoryCache } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { setContext } from "apollo-link-context";

const httpLink = createUploadLink({
  uri: process.env.REACT_APP_URL_GRAPH_QL,
});

const httpLinkNew = createUploadLink({
  uri: process.env.REACT_APP_URL_GRAPH_QL_NEW,
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
    },
  };
});

const client = new ApolloClient({
  connectToDevTools: true,
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink).concat(httpLinkNew),
});

export default client;
